/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
import { url } from '../../../../../../utils/urls';



/* ++++++++++ --------------- MARKETING PAGE - SENTIMENT CONFIGS : STYLES --------------- ++++++++++ */
export default {
    marketing: {
        backgroundColor: themeV2.color.base.white,
        backgroundImage: `url(${url.image}/illustration-bubble-background.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
        backgroundPosition: '100% 100%',
        minHeight: pxToEm(600),
        padding: replacePXinStringWithEM('40px 20px'),
        display: 'flex',
        alignItems: 'center',
        '& .content': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            '& .desc': {
                flex: '1',
                minWidth: pxToEm(300),
                paddingRight: pxToEm(40),
                '& h2': {
                    fontSize: pxToEm(32),
                    fontWeight: 'bold',
                    lineHeight: pxToEm(20),
                    marginBottom: pxToEm(10)
                },
                '& h3': {
                    fontSize: pxToEm(24),
                    fontWeight: 'normal',
                    marginBottom: pxToEm(20)
                },
                '& h4': {
                    fontSize: pxToEm(15),
                    fontFamily: 'arial',
                    fontWeight: 'bold',
                    marginBottom: pxToEm(8)
                },
                '& p': {
                    color: themeV2.color.base.gray.dark,
                    fontSize: pxToEm(16),
                    marginBottom: pxToEm(30)
                },
                '& .ctas': {
                    justifyContent: 'flex-start',
                    marginBottom: pxToEm(30),
                    '& .cta': {
                        marginRight: pxToEm(10)
                    }
                }
            },
            '& .graphic': {
                background: themeV2.color.base.white,
                boxShadow: replacePXinStringWithEM('0px 8px 16px 0px rgba(213, 231, 253, 0.9)'),
                borderRadius: pxToEm(8),
                minWidth: pxToEm(200),
                maxWidth: pxToEm(600),
                padding: pxToEm(20),
                '& img': {
                    width: '100%',
                    height: 'auto'
                }
            }
        }
    }
};
